export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/esm/config.js
// module id = ./node_modules/react-transition-group/esm/config.js
// module chunks = 1